export default __webpack_public_path__ + "static/media/sienas5-min.0d980e90.jpg";